import { render, staticRenderFns } from "./user-setting.vue?vue&type=template&id=514dc046&"
import script from "./user-setting.vue?vue&type=script&lang=js&"
export * from "./user-setting.vue?vue&type=script&lang=js&"
import style0 from "./user-setting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports